var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import getClosedAssetServiceEntries from "../../requests/service/getClosedAssetServiceEntries";
/**
 *
 */
var GetClosedAssetServiceEntriesCommand = /** @class */ (function (_super) {
    __extends(GetClosedAssetServiceEntriesCommand, _super);
    function GetClosedAssetServiceEntriesCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param organisation OrganistionModel
     * @param assetModel AssetModel
     * @param serviceEntryCollection ServiceEntryCollection
     * @return {*}
     */
    GetClosedAssetServiceEntriesCommand.prototype.execute = function (organisation, assetModel, serviceEntryCollection) {
        this.serviceEntryCollection = serviceEntryCollection;
        var promise = getClosedAssetServiceEntries(organisation, assetModel);
        promise.then(this.then);
        return promise;
    };
    /**
     *
     * @param response
     */
    GetClosedAssetServiceEntriesCommand.prototype.then = function (response) {
        this.serviceEntryCollection.reset(false);
        this.serviceEntryCollection.addAll(response);
    };
    return GetClosedAssetServiceEntriesCommand;
}(Command));
export default GetClosedAssetServiceEntriesCommand;
